export default "__VITE_ASSET__dc6f401c__"